import {gql, useQuery} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getMarketplaceTutorial($locale: String!){
	htmlComponentsCollection(
		limit : 1,
		where: { type: "tutorial"}
		locale: $locale
	) {
		items {
			elementsCollection {
				items {
				  ... on HtmlComponents {
						image{
							title
							url
						}
						title
                        type
						sys{
							id
						}
					}
				}
			}
		}
	}
}`;

export const useMarketplaceTutorial = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {loading, data, called} = useQuery(QUERY, {variables: { locale: localeUppercase}, errorPolicy: "all"});

    const items = data?.htmlComponentsCollection.items[0]?.elementsCollection?.items;

    return {
        items,
        loading,
        called
    };
};
